module.exports = __webpack_public_path__ + "img/martin.c4b21836.jpg";